import '@symfony/ux-live-component/dist/live.min.css';
import controller_0 from '@symfony/ux-vue/dist/render_controller.js';

export default [
{
        enabled: true,
        fetch: "lazy",
        identifier: "live",
        controller: () => import("@symfony/ux-live-component/dist/live_controller.js")
      },
{
        enabled: true,
        fetch: "lazy",
        identifier: "symfony--ux-turbo--turbo-core",
        controller: () => import("@symfony/ux-turbo/dist/turbo_controller.js")
      },
{
        enabled: true,
        fetch: "eager",
        identifier: "symfony--ux-vue--vue",
        controller: controller_0
      }
];
